<script setup lang="ts">
import MainLayout from 'views/layouts/MainLayout.vue'
import BoxTitle from 'components/ContactPage/BoxTitle.vue'
</script>
<template>
  <MainLayout>
    <div class="slot-body">
      <div class="l-main mt-5">
        <div class="box-header d-flex">
          <div class="col-lg-5">
            <BoxTitle />
          </div>
          <div class="col-lg-7 d-flex justify-content-end">
            <img :src="imgSrc" alt="Contact"/>
          </div>
        </div>
        <div class="block block--gray">
          <div class="container">
            <div class="row justify-content-center align-items-center padd-left">
              <div class="col-lg-6 col-12 mb-4">
                <h2 class="mb-3">{{ translate.bellaQuestion }}</h2>
                <span class="text" v-html="translate.labelBellaQuastion"></span>
              </div>
              <div class="col-lg-6 col-12">
                <h2 class="mb-3">{{ translate.inviteModel }}</h2>
                <span class="text" v-html="translate.labelInviteModel"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="py-5">
          <BannerAssineHorizontal :path="bannerAssineHorizontal" />
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { localeStore } from 'stores/locale'
import IconeBds from 'assets/img/icone_BDS.png'
import ContactTradutor from 'tradutors/contact'
import BannerAssineHorizontal from 'components/HomePage/BannerAssineHorizontal.vue'
import api from '../../api'
import { isMobile } from "../shared/utils/mobile";

export default defineComponent({
  name: 'ContactUsView',
  computed: {
    ...mapState(localeStore, ['locale']),
    translate: function () {
      if (this.locale === 'pt-br') {
        return ContactTradutor.portugues
      } else {
        return ContactTradutor.ingles
      }
    }
  },
  components: {
    BannerAssineHorizontal
  },
  watch: {
    'locale': function () {
      this.getBannerAssineHorizontal(true)
    }
  },
  mounted() {
    this.getBannerAssineHorizontal()
  },
  head() {
    return {
      templateParams: {
        subTitle: null, 
        subPage: this.locale == 'pt-br' ? 'Contato': 'Contact',
        page_url: window.location.origin + this.$route.fullPath,
        page_description: this.locale == 'pt-br' ?
          `Tem alguma dúvida ou sugestão? Entre em contato com a revista Bella da Semana.` :
          `Do you have any questions or suggestions? Contact Bella Club magazine.`,
        page_image: '/favicon.ico',
        page_keywords: 'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
        page_locale: this.locale,
        page_url_pt: "https://belladasemana.com.br/pt-br/contato",
        page_url_en: "https://belladasemana.com.br/en/contato",
        page_canonical: "https://belladasemana.com.br"+this.$route.fullPath,        
      }
    }
  },
  data() {
    return {
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/featured-image-11.jpg',
      imgPath: IconeBds,
      bannerAssineHorizontal: '',
      isMobile: isMobile(),
    }
  },
  methods: {
    async getBannerAssineHorizontal(changeLanguage = false) {
      if (!sessionStorage.getItem("bannerAssineHorizontal") || changeLanguage)
      api.get(`v1/home/getBannerSuper?mobile=${isMobile()}&language=${this.locale}`).then(({ data }) => {
        this.bannerAssineHorizontal = data.bannerAssineHorizontal
        sessionStorage.setItem(
            "bannerAssineHorizontal",
            JSON.stringify(this.bannerAssineHorizontal)
          );
      })
      else
        this.bannerAssineHorizontal = JSON.parse(
          sessionStorage.getItem("bannerAssineHorizontal")
        );
    }
  }
})
</script>

<style lang="css" scoped>
.box-header {
  margin-bottom: -10px;
}

img {
  width: 100%;
  max-height: 560px;
  object-fit: cover;
}

h2 {
  color: #B20000;
  font-family: 'Roboto-Medium';
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.text {
  display: block;
  color: #5b5858;
  font-family: 'Roboto-Regular';
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

@media screen and (max-width: 992px) {
  img {
    display: none;
  }

  .block-split__header {
    padding-left: 0px;
  }

  .padd-left {
    margin-left: 15px;
  }
}
</style>
